import React, { useEffect } from "react";

const NurseryClassChild = ({ childStatDate, statList, height = 200 }) => {
  useEffect(() => {
    return () => {};
  }, [childStatDate, statList]);
  if (!statList) {
    return (
      <div className="w-100">
        <div className="row">
          <div
            className="col"
            style={{
              height: "220px",
              textAlign: "center",
              paddingTop: `50px`,
            }}
          >
            <span className="dashboard-spinner spinner-xl"></span>
          </div>
        </div>
      </div>
    );
  } else {
    var totalClass = statList.length;    
    var totalContractChild = statList.reduce(
      (ac, current) => ac + (current.contractChild ? current.contractChild : 0),
      0
    );
    var totalChildJoin = statList.reduce(
      (ac, current) => ac + (current.childJoin ? current.childJoin : 0),
      0
    );
    
    const rateJoin = totalContractChild ? ((totalChildJoin / totalContractChild) * 100).toFixed() : 0;
    const heightValue = totalClass > 6 ? height + 'px' : '100%';
    
    return (
      <div className="w-100">
        <div className="text-right text-muted text-xs">
          * 원아 자료 기준일 - {childStatDate}
        </div>
        <table className="table table-sm table-striped text-center">
          <thead style={{display: "table", tableLayout: "fixed", width: "100%"}}>
            <tr className="" style={{backgroundColor: '#b9c7dc'}}>
              <th scope="col">반</th>
              <th scope="col">계약 원아 수</th>
              <th scope="col">회원 가입 수</th>
            </tr>
          </thead>
          <tbody style={{ overflowY: "auto", display: "block", height: heightValue }}>
            {statList.map((s, idx) => (
              <tr key={`class-child-${idx}`} id={`class-child-${s.id}`} style={{display: "table", tableLayout: "fixed", width: "100%"}}>
                <td className="" style={{backgroundColor: '#c8e6ef'}}>{s.name}</td>
                <td>{(s.contractChild ? s.contractChild : 0).toLocaleString()}</td>
                <td>{(s.childJoin ? s.childJoin : 0).toLocaleString()}</td>
              </tr>
            ))}
          </tbody>
          <tfoot>
            <tr className="" style={{color: "#ffffff", display: "table", tableLayout: "fixed", width: "100%", backgroundColor: '#7EC9EB'}}>
              <td>합계</td>
              <td>{totalContractChild.toLocaleString()}</td>
              <td>{totalChildJoin.toLocaleString()}</td>
            </tr>
            <tr className="" style={{display: "table", tableLayout: "fixed", width: "100%", backgroundColor: '#86dd8d'}}>
              <td>가입 비율</td>
              <td className="text-bold" colSpan={2}>
                {rateJoin.toLocaleString()}%
              </td>
            </tr>
          </tfoot>
        </table>
      </div>
    );
  }
};

export { NurseryClassChild };
